<script lang="ts" setup>
import { computed } from 'vue'

import { useTextWithUrlToLink } from '@/components/atoms/TextWithUrlToLink/composables/index'

const { textToTextObjects } = useTextWithUrlToLink()

/**
 * Props
 */
type Props = {
  text: string
}
const props = defineProps<Props>()

/**
 * Content
 */
const textWithUrlToLinksArray = computed(() => {
  return textToTextObjects(props)
})
</script>

<template>
  <template v-for="(stringSegment, index) in textWithUrlToLinksArray">
    <br
      v-if="stringSegment.type === 'newLine'"
      :key="index"
    >

    <span
      v-if="stringSegment.type === 'text'"
      :key="index"
      class="valuetext"
    >
      <slot
        name="text"
        :text="stringSegment.value"
      >
        {{ stringSegment.value }}
      </slot>
    </span>

    <a
      v-if="stringSegment.type === 'url'"
      :key="index"
      :href="stringSegment.value"
      class="valuetext linktext"
      target="_blank"
    >
      <slot
        name="url"
        :url="stringSegment.value"
      >
        {{ stringSegment.value }}
      </slot>
    </a>
  </template>
</template>

<style scoped>
.linktext {
  word-break: break-word;
}
</style>
